var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgf8"},[_c('div',{staticClass:"pt40"},[_c('seafirmsmenu')],1),_c('seafirmscont')],1)}
var staticRenderFns = []

export { render, staticRenderFns }